module.exports = __webpack_public_path__ + "img/collection-weddingRingsMulticolor@2x.827c0ed.webp";